import React, { Component } from "react";
import "../App.css";
import userBanner from "../images/user-banner.png";
import userDemo from "../images/userDemo.png";
import stillness from "../images/stillness.jpg";
import dune from "../images/dune.jpg";
import embrace from "../images/fitness.jpg";
import time from "../images/timeCard.png";
import anxiety from "../images/anxietyCard.png";
import meditate from "../images/meditationCard.png";
import BAM from "../images/bam.png";
import barnesNoble from "../images/barnes-noble.png";
import amazon from "../images/amazon.png";
import google from "../images/google.png";
import sbux from "../images/sbux.png";
import audible from "../images/audible.png";
import { Link } from "react-router-dom";

class UserProfile extends Component {
  render() {
    return (
      <div>
        <section className="user-hero">
          <img
            className="user-banner-img"
            src={userBanner}
            alt="profile-banner"
          ></img>
          <div className="user-info-container">
            <div className="user-info">
              <img src={userDemo} alt="user-pic"></img>
              <h1>Mike Smith</h1>
            </div>
            <div className="user-balance">
              <h2>SpaceCoin Balance: 2406</h2>
              <a>how to earn more</a>
            </div>
          </div>
        </section>
        <section className="profile-grid-container">
          <h1 className="user-section-1">My Reading List</h1>
          <img className="user-books-1" src={stillness} alt="stillness"></img>
          <img className="user-books-2" src={dune} alt="dune"></img>
          <img className="user-books-3" src={embrace} alt="embrace"></img>
          <h3 className="remove1">Remove List</h3>
          <h3 className="remove2">Remove List</h3>
          <h3 className="remove3">Remove List</h3>
          <h1 className="user-section-2">Most Visited Categories</h1>

          <div className="user-section-2-most-visited">
            <div className="pop-topics-1">
              <div className="sub-cat-card-wrapper">
                <Link
                  to="/mindfulness/philosophies-of-time"
                  className="sub-cat-card"
                >
                  <img src={time} alt="time" />
                </Link>
                <h2 className="sub-cat-card-title">Philosophies of Time</h2>
              </div>
              <div className="sub-cat-card-wrapper">
                <Link
                  to="/mindfulness/aleviate-anxiety"
                  className="sub-cat-card"
                >
                  <img src={anxiety} alt="anxiety" />
                </Link>
                <h2 className="sub-cat-card-title">Alleviate Anxiety</h2>
              </div>
              <div className="sub-cat-card-wrapper">
                <Link
                  to="/mindfulness/meditation-is-key"
                  className="sub-cat-card"
                >
                  <img src={meditate} alt="meditate" />
                </Link>
                <h2 className="sub-cat-card-title">Meditation is Key</h2>
              </div>
            </div>
          </div>

          <h1 className="user-section-3">SpaceCoin Shop</h1>
          <img className="shop-img-1" src={BAM} alt="books-a-million"></img>
          <img
            className="shop-img-2"
            src={barnesNoble}
            alt="barnes-noble"
          ></img>
          <img className="shop-img-3" src={amazon} alt="amazon"></img>
          <img className="shop-img-4" src={google} alt="google"></img>
          <img className="shop-img-5" src={sbux} alt="starbucks"></img>
          <img className="shop-img-6" src={audible} alt="audible"></img>
        </section>
      </div>
    );
  }
}

export default UserProfile;
